module.exports = __webpack_public_path__ + "images/leader-beater-4b10a402c4772f98d1c29225c8833021.png";